import saldoOverModel from "./saldoOver";
const TYPE = "vendedor";
const vendedorModule = {
  buscarPorIdIntegracao: async (dbConnection, idIntegracao) => {
    let vendedor = null;
    let result = await dbConnection.find({
      selector: {
        type: { $eq: TYPE },
        idIntegracao: { $eq: idIntegracao },
      },
    });

    if (result.docs.length) {
      vendedor = result.docs[0];

      let saldoAtual = await saldoOverModel.getSaldoOver(
        dbConnection,
        vendedor.idIntegracao
      );

      vendedor.vlOver += saldoAtual.qtdAcrescentar;
      vendedor.vlOver -= saldoAtual.qtdDescontar;

      if (vendedor.vlOver < 0) vendedor.vlOver = 0;
    }

    return vendedor;
  },
};

export default vendedorModule;
